import React, { useEffect, useRef, useContext } from 'react'
import { Context } from '../..';
import { NavLink } from 'react-router-dom'
import {
  CContainer,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  useColorModes,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilContrast,
  cilAccountLogout,
  cilMenu,
  cilMoon,
  cilSun,
} from '@coreui/icons'
import  Sidebar  from './AppSidebar'
import sidebarStore from '../../store/SidebarStore'

const AppHeader = () => {
  const {store} = useContext(Context)
  const headerRef = useRef()
  const { colorMode, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')

  const handleLogOut = () => {
    store.logout();
  }

  const showBar = () => {
    sidebarStore.setShow(!sidebarStore.show)
  }


  useEffect(() => {
    document.addEventListener('scroll', () => {
      headerRef.current &&
        headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0)
    })
  }, [])

  return (
    <CHeader position="sticky" className="header mb-4 p-0" ref={headerRef}>
      <CContainer className="border-bottom px-4" fluid>
        <Sidebar/>
        <CHeaderToggler
          onClick={showBar}
          style={{ marginInlineStart: "-14px", position: "relative", zIndex: 9999 }}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderNav className="d-flex" >
          <CNavItem>
            <CNavLink to="/dashboard" as={NavLink}>
              Dashboard
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink to="/settings" as={NavLink}>
              Настройки
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-auto d-flex flex-row align-items-center flex-nowrap">
          <CNavItem className="d-flex align-items-center">
            <CNavLink href="#" className="py-2">
              <CIcon icon={cilBell} size="lg" />
            </CNavLink>
          </CNavItem>
          <CNavItem className="d-flex align-items-center">
            <CNavLink
              as="button"
              type="button"
              className="nav-link border-0 bg-transparent py-2 px-2 d-inline-flex align-items-center"
              onClick={handleLogOut}
              aria-label="Выйти"
            >
              <CIcon icon={cilAccountLogout} size="lg" />
            </CNavLink>
          </CNavItem>
          <li className="nav-item align-self-stretch d-flex align-items-center py-1">
            <div className="vr align-self-stretch mx-2 text-body text-opacity-75" />
          </li>
          <CDropdown variant="nav-item" placement="bottom-end" className="d-flex align-items-center">
            <CDropdownToggle caret={false}>
              {colorMode === 'dark' ? (
                <CIcon icon={cilMoon} size="lg" />
              ) : colorMode === 'auto' ? (
                <CIcon icon={cilContrast} size="lg" />
              ) : (
                <CIcon icon={cilSun} size="lg" />
              )}
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                active={colorMode === 'light'}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => setColorMode('light')}
              >
                <CIcon className="me-2" icon={cilSun} size="lg" /> Light
              </CDropdownItem>
              <CDropdownItem
                active={colorMode === 'dark'}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => setColorMode('dark')}
              >
                <CIcon className="me-2" icon={cilMoon} size="lg" /> Dark
              </CDropdownItem>
              <CDropdownItem
                active={colorMode === 'auto'}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => setColorMode('auto')}
              >
                <CIcon className="me-2" icon={cilContrast} size="lg" /> Auto
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
